import { createAction } from '@ngrx/store';

export const validateSamplesSSA = createAction(
    '[Samples/ValidateSamples] Validate samples'
);
